import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { compareAlphabetically } from '@shared/utils/helpers/sort-helpers';
import { uniqBy } from '@shared/utils/helpers/uniqBy';
import { type LearnContentCarouselCardFragment } from '../../../../../utils/data/graphql/_generated/gql-generated';
import { isNonNullable } from '../../../../../utils/helpers/type-compatible-filter-functions';
import { type LearnCarouselCardData } from '../../../actions/types';
export type UseCarouselSourceFilterProps = {
  cards: LearnContentCarouselCardFragment[];
  selectedSourcesIds: number[];
  showSourcesFilter: boolean;
  sourcesFilterAllSelectionLabel: null | string | undefined;
};
export const useCarouselSourceFilter = t0 => {
  const $ = _c(18);
  const {
    cards,
    selectedSourcesIds,
    showSourcesFilter,
    sourcesFilterAllSelectionLabel
  } = t0;
  const [currentSourceIdFilter, setCurrentSourceIdFilter] = useState(null);
  if (!showSourcesFilter) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        filterCardsBySelectedSource: _temp,
        setCurrentSourceIdFilter,
        sourceFilterItems: []
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== cards || $[2] !== currentSourceIdFilter || $[3] !== selectedSourcesIds || $[4] !== sourcesFilterAllSelectionLabel) {
    const cardCategories = cards.flatMap(_temp2)?.filter(isNonNullable);
    let t2;
    if ($[6] !== selectedSourcesIds) {
      t2 = category => selectedSourcesIds.includes(category.Id ?? 0);
      $[6] = selectedSourcesIds;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    const cardUniqueSourceCategories = uniqBy(cardCategories.filter(t2), _temp3).filter(_temp4).sort(_temp5);
    const t3 = sourcesFilterAllSelectionLabel || "All meetings";
    const t4 = currentSourceIdFilter === null;
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
      t5 = {
        label: t3,
        selected: t4,
        value: null
      };
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== currentSourceIdFilter) {
      t6 = sourceCategory => ({
        label: sourceCategory.Name,
        selected: sourceCategory.Id === currentSourceIdFilter,
        value: sourceCategory.Id ?? 0
      });
      $[11] = currentSourceIdFilter;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t1 = [t5, ...cardUniqueSourceCategories.map(t6)];
    $[1] = cards;
    $[2] = currentSourceIdFilter;
    $[3] = selectedSourcesIds;
    $[4] = sourcesFilterAllSelectionLabel;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const sourceFilterItems = t1;
  let t2;
  if ($[13] !== currentSourceIdFilter) {
    t2 = cardsArgument_0 => currentSourceIdFilter === null ? cardsArgument_0 : cardsArgument_0.filter(card_0 => card_0.ExpandedCategories?.some(category_2 => category_2?.Id === currentSourceIdFilter));
    $[13] = currentSourceIdFilter;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== sourceFilterItems || $[16] !== t2) {
    t3 = {
      filterCardsBySelectedSource: t2,
      setCurrentSourceIdFilter,
      sourceFilterItems
    };
    $[15] = sourceFilterItems;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
function _temp(cardsArgument) {
  return cardsArgument;
}
function _temp2(card) {
  return card.ExpandedCategories;
}
function _temp3(category_0) {
  return category_0.Id ?? "";
}
function _temp4(category_1) {
  return category_1.Id;
}
function _temp5(categoryA, categoryB) {
  return compareAlphabetically(categoryA.Name, categoryB.Name);
}